import type {Insight} from "../../../models/api/insight/Insight";
import {insights as insights20250114} from "./20250114";
import {insights as insights20250318} from "./20250318";
import {insights as insights20250410} from "./20250410";
import {insights as insights20250416} from "./20250416";
import {insights as insights20250424} from "./20250424";
import {insights as insights20250724} from "./20250724";
import {insights as insights20250902} from "./20250902";
import {insights as insights20250911} from "./20250911";
import {insights as insights20251014} from "./20251014";
import {insights as insights20251021} from "./20251021";
import {insights as insights20251210} from "./20251210";

const insights: Array<Insight> = [
    ...insights20251210,
    ...insights20251021,
    ...insights20251014,
    ...insights20250911,
    ...insights20250902,
    ...insights20250724,
    ...insights20250424,
    ...insights20250416,
    ...insights20250410,
    ...insights20250318,
    ...insights20250114,
];

export {
    insights,
};
